export default __webpack_public_path__ + "static/media/cyprus-overload.056556e6.png";